import {API_URL, apiGetV1} from '../api'
import {ApiRes} from '../../types/api'

interface IInvoiceFeeMonthly {
    month_amount: number
    month_count: number
    month_paid_amount: number
    month_paid_count: number
    when: number
}

export const getInvoiceDataMonthly = async (): Promise<ApiRes<IInvoiceFeeMonthly[]>> => {
    return await apiGetV1(API_URL, `admin/invoice_data/monthly`)
}
